module.exports = __webpack_public_path__ + "593a3d53/img/placeholder.888fcd0b.svg";